<template>
  <div class="plan-offering">
    <p v-if="callfyQuotaLine && !hideCallfyQuota" class="plan-offering__callfy-quota">
      <i class="bi bi-whatsapp me-2 text-success"></i>
      {{ callfyQuotaLine }}
    </p>

    <p v-if="seatBillingLine" class="plan-offering__seat-billing">
      <i class="bi bi-people me-2 text-primary"></i>
      {{ seatBillingLine }}
    </p>

    <template v-if="presentation?.mode === 'enterprise'">
      <p v-if="presentation.inherits_plan" class="plan-offering__inherit">
        <i class="bi bi-layers me-2 text-primary"></i>
        Inclui tudo do plano <strong>{{ presentation.inherits_plan.name }}</strong>
      </p>
      <p v-if="presentation.summary" class="text-muted plan-offering__summary">{{ presentation.summary }}</p>
      <div class="plan-offering__enterprise-badge">Exclusivo Enterprise</div>
      <ul class="plan-offering__exclusive-list">
        <li v-for="module in presentation.enterprise_exclusive_modules" :key="module.slug">
          <span class="plan-offering__module-name">{{ module.name }}</span>
          <ul class="plan-offering__feature-sublist" v-if="module.features?.length">
            <li v-for="feature in module.features" :key="feature.slug">{{ feature.name }}</li>
          </ul>
        </li>
      </ul>
    </template>

    <template v-else-if="presentation?.mode === 'compact'">
      <p class="plan-offering__inherit">
        <i class="bi bi-layers me-2 text-primary"></i>
        Tudo do plano <strong>{{ presentation.inherits_plan?.name }}</strong>
      </p>
      <p v-if="presentation.additional_feature_groups?.length || presentation.additional_exclusive_features?.length" class="plan-offering__plus-label">Mais:</p>
      <ul class="plan-offering__exclusive-list">
        <li v-for="group in presentation.additional_feature_groups" :key="group.slug">
          <span class="plan-offering__module-name">{{ group.name }}</span>
          <ul class="plan-offering__feature-sublist" v-if="group.features?.length">
            <li v-for="feature in group.features" :key="feature.slug">{{ feature.name }}</li>
          </ul>
        </li>
        <li v-for="feature in presentation.additional_exclusive_features" :key="feature.slug">
          <span class="plan-offering__module-name">{{ feature.name }}</span>
        </li>
      </ul>
    </template>

    <template v-else>
      <ul class="plan-offering__exclusive-list">
        <li v-for="group in presentation?.feature_groups || featureGroups" :key="group.slug">
          <span class="plan-offering__module-name">{{ group.name }}</span>
          <ul class="plan-offering__feature-sublist" v-if="group.features?.length">
            <li v-for="feature in group.features" :key="feature.slug">{{ feature.name }}</li>
          </ul>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PlanOfferingPresentation',
  props: {
    presentation: {
      type: Object,
      default: null,
    },
    featureGroups: {
      type: Array,
      default: () => [],
    },
    hideCallfyQuota: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    callfyQuotaLine() {
      const quota = this.presentation?.callfy_quota;
      if (!quota) {
        return null;
      }

      if (quota.unlimited) {
        return 'Envios WhatsApp automáticos ilimitados por ciclo';
      }

      if (quota.trial_period) {
        return `${quota.included} envios WhatsApp automáticos no período de teste`;
      }

      if (quota.included === 0) {
        return 'Sem envios automáticos WhatsApp incluídos';
      }

      return `${quota.included} envios WhatsApp automáticos por ciclo`;
    },
    seatBillingLine() {
      const seat = this.presentation?.seat_billing;
      if (!seat || seat.extra_professional_price == null) {
        return null;
      }

      const price = Number(seat.extra_professional_price).toFixed(2).replace('.', ',');
      const included = Number(seat.included_professionals ?? 0);

      if (included > 0) {
        return `R$ ${price} por profissional adicional (acima de ${included} incluído(s))`;
      }

      return `R$ ${price} por profissional adicional`;
    },
  },
};
</script>

<style scoped>
.plan-offering__callfy-quota {
  font-size: 0.875rem;
  font-weight: 600;
  color: #3f4254;
  margin: 0 0 0.85rem;
}

.plan-offering__seat-billing {
  font-size: 0.875rem;
  font-weight: 600;
  color: #3f4254;
  margin: 0 0 0.85rem;
}

.plan-offering__inherit {
  font-size: 0.95rem;
  margin-bottom: 0.75rem;
  color: #181c32;
}

.plan-offering__summary {
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.plan-offering__enterprise-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #7239ea;
  background: #f8f5ff;
  border-radius: 6px;
  padding: 0.25rem 0.5rem;
  margin-bottom: 0.75rem;
}

.plan-offering__exclusive-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.plan-offering__exclusive-list > li {
  margin-bottom: 0.85rem;
}

.plan-offering__module-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #3f4254;
}

.plan-offering__feature-sublist {
  list-style: none;
  margin: 0.35rem 0 0;
  padding: 0 0 0 1rem;
  color: #7e8299;
  font-size: 0.8rem;
}

.plan-offering__feature-sublist li {
  margin-bottom: 0.2rem;
}

.plan-offering__plus-label {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #7e8299;
  margin: 0.5rem 0 0.35rem;
}
</style>
